import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src", "alt"];
import { computed } from 'vue';
import AppUtil from '@util/AppUtil';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageFrame',
    props: {
        src: { default: '' },
        alt: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const formatImagePath = computed(() => {
            var _a;
            const pattern = /[http|https]:\/\//g;
            const src = (_a = props.src) !== null && _a !== void 0 ? _a : '';
            // http httpsが付いていたら、そのまま画像表示する
            if (pattern.test(src)) {
                return src;
            }
            // http httpsが付いてなければ、リソースファイルと判断してパスを加工する
            return AppUtil.cvtRemotePath(src);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("img", {
                src: _unref(formatImagePath),
                alt: props.alt
            }, null, 8, _hoisted_1));
        };
    }
});
